export default class Terms {

	constructor(name) {

		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			items: [],
			count: 0,
			interval: 2000,
			query: '',

			init() {
				var vm = this;
				var xhttp = new XMLHttpRequest();

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						vm.items = JSON.parse(this.responseText);
					}
				}
				xhttp.open('get', '/api/dashboard', true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send();
				
			},

			loop(vm = this){
				setInterval(function(){
					vm.count += ( 100 / 60 )
					if( vm.count >= 100){
						vm.init();
						vm.count = 0;
					}
				}, vm.interval )
			},

			EditItem(Item) {
				if(Item.task_id) return this.OpenTask(Item)

				Turbolinks.visit( '/term/' + Item.term_id + '/item/' + Item.id )
			},

			OpenTask(Task){
				Turbolinks.visit( '/task/' + Task.task_id)
			},

			OpenIssue(Issue){
				Turbolinks.visit( '/term/' + Issue.term_id + '/item/' + Issue.item_id + '/issue/' +  Issue.id)	
			},

			CreateTestReport(Item){
				Turbolinks.visit( '/term/' + Item.term_id + '/item/' + Item.id + '/test-report/create')	
			},

			filterItems(vm = this) {

				var AllItems = vm.items;
				var SearchableKeys = ['name']
				var SearchString = vm.query.toLowerCase();

				return AllItems.filter(product => {
					let flag = false;
					for (let SearchKey of SearchableKeys) {
						if( product[SearchKey] ){
							flag = product[SearchKey].toString().toLowerCase().indexOf(SearchString) > -1
						}
						if (flag) break;
					}
					return flag;
				});
			}
		}
	}
}